<template>
  <transition name="slide-fade">
    <div class="row justify-content-center" v-if="alert.message">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="alert-message" :class="`alert ${alert.type}`">{{alert.message}}</div>
      </div>
    </div>
  </transition>
</template>
<script>
import { mapState } from 'vuex';

export default{
  name: 'AlertMessage',
  computed: {
    ...mapState({
      alert: state => state.alert
    })
  }
};
</script>

<style>
.alert-message {
  border-radius: .3rem;
  box-shadow: none;
}
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// source/components/AlertMessage.vue